import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Grid, IconButton } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import AdminTable from "components/UpdateUi/Table/AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { formatAmount } from "utils/Utils";
import { saveUserLeadId } from "store/reducers/login/LoginSlice";
import {
  normalizeName,
  parseAndSetFlag,
  parseDate,
  parseDateMDY,
  parseTimeDate,
  removeUnderscoresAndCapitalize,
  textFormat,
} from "../../../utils/Utils";
import { adminPanelTableColumns } from "assets/properties/properties";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { saveUserData } from "store/reducers/login/LoginSlice";
import * as XLSX from "xlsx";
import { adminPortalTableColumns } from "assets/properties/properties";
import PhoneIVR from "./PhoneIVR";
import { enableIvr } from "assets/properties/properties";
const AdminPortal = ({ classes }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outletData = useOutletContext();
  const { authToken } = useSelector((state) => state.login.authData);
  const { mobileNumber } = useSelector((state) => state.login.userData);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const status = location.state?.status || "INPROCESS";
  useEffect(() => {
    getUserDetails();
  }, [status]);
  const getDefaultDateRange = () => {
    const today = new Date();

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    return {
      startDate: parseDate(sevenDaysAgo),
      endDate: parseDate(today),
    };
  };
  const getUserDetails = async () => {
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
    const { startDate, endDate } = getDefaultDateRange();
    setStartDate(startDate);
    setEndDate(endDate);
    getUserLoanDetails(result?.data, startDate, endDate);
  };
  const getUserLoanDetails = async (
    userDetails,
    filterStartDate = "",
    filterEndDate = "",
    filterSearch = ""
  ) => {
    setCallInProgress(true);
    const applicationStatus = status === "APPROVED" ? "INPROCESS&decision=APPROVED" : status;
    const result = await apiHandler({
      url:
        endpoint.LEAD_SEARCH_API +
        applicationStatus +
        `&startDate=${filterStartDate}&endDate=${filterEndDate}`,
      method: "GET",
      authToken: authToken,
    });

    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);

      parseIndicatorData(result?.data, userDetails, filterSearch);
    }
  };
  const renderPhoneIcon = (createdBy, mobileNumber, userDetails) => {
    if (!enableIvr && mobileNumber?.length < 10 && !mobileNumber) {
      return createdBy;
    }
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <PhoneIVR
          classes={classes}
          authToken={authToken}
          customerPhoneNumber={mobileNumber}
          branchCode={location?.state?.branchCode}
          agentMobileNumber={userDetails?.mobileNumber}
        />
        {createdBy}
      </div>
    );
  };
  const parseIndicatorData = (data, userDetails, searchText = "") => {
    let reportData = [];

    data = data?.sort((a, b) => (a?.id < b?.id ? 1 : -1));

    data &&
      data.forEach((leadDetails, index) => {
        let row = {
          id: index + 1,
          leadId: leadDetails?.id,
          created: renderPhoneIcon(
            leadDetails?.createdBy,
            leadDetails?.mobileNumber,
            userDetails
          ),
          createdBy: leadDetails?.createdBy,
          createdOn: parseTimeDate(leadDetails?.createdOn),
          accountNumber: leadDetails?.loanAccountNumber,
          customerid: leadDetails?.customerId,
          customerName: leadDetails?.name,
          maxEligibleLoanAmount: formatAmount(leadDetails?.maxEligibleLoanAmount),
          action:
            status !== "COMPLETED" && status !== "REJECTED"
              ? getIcons(leadDetails)
              : null,
        };

        reportData.push(row);
      });
    setTableData(reportData);
    const searchTextValue = String(searchText || "")
      .toLowerCase()
      .trim();

    if (!searchTextValue) {
      setSelectedTableData(reportData);
      return;
    }

    const filteredData = reportData.filter(
      (row) =>
        String(row?.leadId || "")
          .toLowerCase()
          .includes(searchTextValue) ||
        String(row?.accountNumber || "")
          .toLowerCase()
          .includes(searchTextValue) ||
        String(row?.createdBy || "")
          .toLowerCase()
          .includes(searchTextValue) ||
        String(row?.createdOn || "")
          .toLowerCase()
          .includes(searchTextValue) ||
        String(row?.customerid || "")
          .toLowerCase()
          .includes(searchTextValue) ||
        String(row?.customerName || "")
          .toLowerCase()
          .includes(searchTextValue)
    );

    setSelectedTableData(filteredData);
  };
  const getIcons = (leadDetails) => {
    return (
      <>
        <IconButton
          aria-label="Edit scheme"
          onClick={(e) => {
            e.stopPropagation();
            onProceedClick(leadDetails);
            dispatch(
              saveUserData({
                name: leadDetails?.name ? leadDetails?.name : "",
                mobileNumber: leadDetails?.mobileNumber,
              })
            );
          }}
        >
          <ArrowForwardIcon />
        </IconButton>
      </>
    );
  };
  const onProceedClick = async (data) => {
    console.log(data, "dafkjabdfjk");
    dispatch(
      saveUserLeadId({
        leadId: data?.id ? data?.id : "",
        leadStatus: data?.status ? data?.status : "",
      })
    );

    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.USER_PROFILE_SCREEN_FLAGS_API + data?.id, // Fixed: `id` was undefined
      method: "GET",
      authToken: authToken,
    });

    setCallInProgress(false);

    const flags = result?.data;
    if (!flags.applicantIncomeDetail) {
      navigate("/journey/IncomeDetails", { state: { id: data?.id } });
      return;
    }
    const cibilResult = await apiHandler({
      url: endpoint.GET_CUSTOMER_CIBIL + data?.id,
      method: "GET",
      authToken: authToken,
    });
    if (cibilResult?.data?.error_code) {
      navigate("/journey/AadharDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (
      !flags.applicantBankAnalyser ||
      (!flags.bre && flags.applicantBankAnalyser)
    ) {
      navigate("/journey/BankAnalyser", {
        state: { id: data?.id, status: status, breSuccess: flags.bre },
      });
      return;
    }
    if (!flags.applicantPhotoKyc) {
      navigate("/journey/SelfiePhoto", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.applicantDetail) {
      navigate("/journey/GeneralDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.applicantLeadReferal) {
      navigate("/journey/ReferenceDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.loanTenure) {
      navigate("/journey/LoanTenureDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.repaymentScheduleDetail) {
      navigate("/journey/RepaymentScheduleDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.applicantBankDetail) {
      navigate("/journey/BankDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.sanctionLetter) {
      navigate("/journey/SanctionLetter", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.sanctionLetterEstamp && parseAndSetFlag(outletData.eStampFlag)) {
      navigate("/journey/EstampSanctionLetter", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.sanctionLetterEsign) {
      navigate("/journey/SanctionLetter", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.mandateDetail) {
      navigate("/journey/MandateDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (!flags.disbursal) {
      navigate("/journey/DisbursalDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
    if (flags.disbursal) {
      navigate("/completedDetails", {
        state: { id: data?.id, status: status },
      });
      return;
    }
  };

  const CreateApplication = async () => {
    dispatch(
      saveUserLeadId({
        leadId: "",
        leadStatus: "",
      })
    );
    navigate("/journey/IncomeDetails");
  };
  const onRowClick = (rowData) => {
    navigate(`/personalLoanDetails/${rowData?.leadId}`, {
      state: { status: status },
    });
  };
  const handleSearchChange = (value) => {
    setSearchValue(value);

    const searchText = String(value || "")
      .toLowerCase()
      .trim();

    if (!searchText) {
      setSelectedTableData(tableData);
      return;
    }

    const filteredData = tableData.filter(
      (row) =>
        String(row?.leadId || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.accountNumber || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.createdBy || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.createdOn || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.customerid || "")
          .toLowerCase()
          .includes(searchText) ||
        String(row?.customerName || "")
          .toLowerCase()
          .includes(searchText)
    );

    setSelectedTableData(filteredData);
  };
  const handleSearchApplications = () => {
    getUserLoanDetails(null, startDate, endDate, searchValue);
  };
  const handleExportExcel = () => {
    const fileData = [];
    fileData.push(adminPortalTableColumns);
    // Data
    rawData.forEach((row) => {
      fileData.push([
        row?.id,
        row.loanAccountNumber || "",
        parseDateMDY(row?.createdOn),
        row?.customerId,
        textFormat(row?.name),
        row?.mobileNumber || "",
        removeUnderscoresAndCapitalize(row?.status?.toLowerCase()) || "",
      ]);
    });

    exportNegativeRegistry(fileData, `${status}_leads.xlsx`);
  };

  const exportNegativeRegistry = (fileData, fileName) => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(fileData);

    ws["!cols"] = [
      { wch: 25 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 30 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Negative Registry");

    XLSX.writeFile(wb, fileName);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={`${normalizeName(status)}`}
          dateFilter
          searchLabel="Search"
          searchValue={searchValue}
          onSearchChange={handleSearchChange}
          fromDate={startDate}
          toDate={endDate}
          onFromDateChange={setStartDate}
          onToDateChange={setEndDate}
          onDateSearch={handleSearchApplications}
          searchButtonLabel="Search"
          button1="Download"
          button1click={handleExportExcel}
          noButton
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <AdminTable
          columns={adminPanelTableColumns}
          rows={selectedTableData}
          onRowClick={onRowClick}
          searchValue={searchValue}
        />
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

AdminPortal.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default AdminPortal;
